<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="collapse navbar-collapse">
        <ul class="nav navbar-nav">
          <li class="nav-item">
            <router-link
              to="/"
              class="nav-link"
              style="font-size: larger; color: white"
              >Home</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/contrats" class="nav-link">Contrats</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/titulaires" class="nav-link"
              >Titulaires</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/remplacants" class="nav-link"
              >Remplaçants</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/gardes" class="nav-link">Gardes</router-link>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Intérim
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <router-link class="dropdown-item" to="/contrats_interim"
                >Contrats d'interim</router-link
              >
              <router-link class="dropdown-item" to="/interimaires"
                >Intérimaires</router-link
              >
              <router-link class="dropdown-item" to="/iades">Iades</router-link>
            </div>
          </li>
          <li class="nav-item" v-if="$store.state.role === 'admin'">
            <router-link to="/users" class="nav-link">Utilisateurs</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/about" class="nav-link">A propos</router-link>
          </li>
        </ul>
      </div>
      <ul class="nav navbar-nav navbar-right">
        <li>
          <button
            v-if="$store.getters.isAuthenticatedByToken"
            class="btn btn-danger log"
            @click="logout()"
          >
            Log out
          </button>
          <button
            v-if="!$store.getters.isAuthenticatedByToken"
            class="btn btn-info log"
            @click="login()"
          >
            Log In
          </button>
        </li>
      </ul>
    </nav>
    <div
      v-if="welcomeString"
      class="alert alert-success  text-right"
      role="alert"
      style=" height: 40px;"
    >
      <p>{{ welcomeString }} {{ roleString }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "app-nav",
  data() {
    return {
      welcomeString: this.$store.state.isAuthenticated
        ? this.$store.state.email
        : "",
      roleString: this.$store.state.role
    };
  },
  methods: {
    login: function() {
      this.$router.push({ name: "Login" });
    },
    logout: function() {
      this.$store.dispatch("logout");
    }
  }
};
</script>
<style scoped>
.navbar-right {
  margin-right: 0px !important;
}

.log {
  margin: 5px 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// AppNav.vue?65418dcc